import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface BookingContactProfile {
  firstName: string;
  lastName: string;
  email: string;
  phone: string | null;
  customerId: string;
}

export interface BookingContactSyncStatus {
  factuProfile: { companyName: string; email: string | null; phone: string | null };
  bookitProfile: BookingContactProfile | null;
}

@Injectable({ providedIn: 'root' })
export class BookingContactService {
  constructor(private http: HttpClient) {}

  getSyncStatus(contactUid: string): Observable<BookingContactSyncStatus> {
    return this.http.get<BookingContactSyncStatus>(
      `${environment.apiUrl}/api/v2/booking/contacts/${contactUid}/sync-status`
    );
  }

  sync(
    contactUid: string,
    data: {
      firstName?: string;
      lastName?: string;
      email?: string;
      phone?: string;
      factuCompanyName?: string;
      factuEmail?: string;
      factuPhone?: string;
    }
  ): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/api/v2/booking/contacts/${contactUid}/sync`,
      data
    );
  }
}
